import { baseApi } from './baseApi';
import type { Money } from './types';

/** The single coupon currently featured on the landing page, if any. */
export interface AdvertisedCoupon {
  code: string;
  discountType: 'PERCENTAGE' | 'FIXED';
  discountValue: number;
  fixedAmount?: Money;
  expiresAt: string;
}

export const couponsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // A 204 (nothing advertised) resolves to an empty body, not an error —
    // fall back to null so the banner has a simple presence check.
    advertisedCoupon: builder.query<AdvertisedCoupon | null, void>({
      query: () => 'public/coupons/advertised',
      transformResponse: (response: AdvertisedCoupon | undefined) => response ?? null,
      providesTags: ['Coupon'],
    }),
  }),
});

export const { useAdvertisedCouponQuery } = couponsApi;
